import { cloneElement, FC, useState } from 'react';
import { Grid, Svg, Text } from '@hopskipdrive/react-components';

import {
  Container,
  CornerWrapper,
  RideOverviewContainer,
  RideOverviewContent,
  RideOverviewOuterContainer,
  RideOverviewTab,
  RideOverviewTabs,
} from './RideOverview.styles';

interface RideOverviewProps {
  currentTab: string;
  onTabClick: (tabName: string) => void;
  baseHeight: string;
  tabs: {
    tabLabel: string;
    value: string;
    disabled?: boolean;
    hidden?: boolean;
    dataTestId?: string;
    Component: () => JSX.Element;
    scrollHeight?: string;
  }[];
  errorText?: string;
}

export const RideOverview: FC<RideOverviewProps> = ({ currentTab, onTabClick, baseHeight, tabs, errorText }) => {
  const [isExpand, setIsExpand] = useState(false);

  const scrollHeight = (() => {
    return tabs.find((tab) => tab.value === currentTab)?.scrollHeight || (isExpand ? 'auto' : baseHeight);
  })();

  const showExpand = currentTab && parseInt(scrollHeight) > parseInt(baseHeight);

  const handleTabClick = (tabName) => {
    onTabClick(tabName);
    setIsExpand(false);
  };

  const tabsToRender = tabs.filter((tab) => !tab.hidden);

  return (
    <RideOverviewOuterContainer>
      <Container>
        {currentTab && showExpand && (
          <CornerWrapper onClick={() => setIsExpand(!isExpand)}>
            <Svg icon={isExpand ? 'collapse' : 'expand'} />
          </CornerWrapper>
        )}
        <RideOverviewContainer mt={2} data-testid="overview-tabs">
          <Grid container alignItems="baseline" mt={2} mb={6}>
            <RideOverviewTabs value={currentTab} variant="scrollable">
              {tabsToRender.map((tab) => (
                <RideOverviewTab
                  key={tab.value}
                  label={tab.tabLabel}
                  value={tab.value}
                  disabled={tab.disabled}
                  data-testid={tab.dataTestId}
                  {...(tabs.length > 1 && { onClick: () => handleTabClick(tab.value) })}
                />
              ))}
            </RideOverviewTabs>
            {errorText && <Text variant="h3">{errorText}</Text>}
          </Grid>
          <RideOverviewContent height={isExpand ? scrollHeight : baseHeight} container className="main">
            {tabsToRender.map((tab) =>
              currentTab !== tab.value ? null : cloneElement(tab.Component(), { key: `component-for-${tab.value}` })
            )}
          </RideOverviewContent>
        </RideOverviewContainer>
      </Container>
    </RideOverviewOuterContainer>
  );
};
